import type { FieldValues } from 'react-hook-form';
import type { FieldSpec } from './FormFields';

// defineFields keeps per-page field lists checked against the form value shape.
export function defineFields<T extends FieldValues>(fields: readonly FieldSpec<T>[]) {
  return fields;
}
